import { render, staticRenderFns } from "./AddMaterial.vue?vue&type=template&id=efb066b2&scoped=true"
import script from "./AddMaterial.vue?vue&type=script&lang=js"
export * from "./AddMaterial.vue?vue&type=script&lang=js"
import style0 from "./AddMaterial.vue?vue&type=style&index=0&id=efb066b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb066b2",
  null
  
)

export default component.exports